// extracted by mini-css-extract-plugin
export default {"grid":"ThreeByOneWidgetGrid_grid__laSGe"};